import getInitialCylinderConfigurationVariantSku from "@secureo/common/utils/commerceTools/getInitialCylinderConfigurationVariantSku"
import fetchCylinderConfigurationVariant from "./fetchCylinderConfigurationVariant"
import fetchProductIdsBySku from "./fetchProductIdsBySku"
import getLanguageAndCountryCodeFromLocale from "@secureo/common/utils/i18n/getLanguageAndCountryCodeFromLocale"

import {
	ProductAttributes,
	CylinderConfigurationVariant,
	Product,
} from "@secureo/common/typings/Product"
import { CountryCode } from "@secureo/common/typings/CountryCode"

const getCylinderLockingMechanismProducts = async (
	accessToken: string,
	masterVariantAttributes: ProductAttributes,
	countryCode: CountryCode,
) => {
	const cylinderLockingMechanismSkus =
		masterVariantAttributes?.cylinderLockingMechanismSkusByCountryCode?.[countryCode]

	if (cylinderLockingMechanismSkus) {
		const { single, simultaneous } = cylinderLockingMechanismSkus

		const cylinderLockingMechanismProductIdsBySku = await fetchProductIdsBySku(accessToken, [
			single.sku,
			simultaneous.sku,
		])

		const cylinderLockingMechanismProducts: Product["cylinderLockingMechanismProducts"] = {
			single: {
				productId: cylinderLockingMechanismProductIdsBySku?.[single.sku] ?? null,
				variantId: 1,
				sku: single.sku,
				netPriceCents: single.netPriceCents,
			},
			simultaneous: {
				productId: cylinderLockingMechanismProductIdsBySku?.[simultaneous.sku] ?? null,
				variantId: 1,
				sku: simultaneous.sku,
				netPriceCents: simultaneous.netPriceCents,
			},
		}

		return cylinderLockingMechanismProducts
	}

	return null
}

const fetchInitialCylinderConfigurations = async (
	accessToken: string,
	masterVariantSku: string,
	masterVariantAttributes: ProductAttributes,
	locale: string,
) => {
	let initialCylinderConfigurationVariant: CylinderConfigurationVariant = null
	const initialCylinderConfigurationVariantSku = getInitialCylinderConfigurationVariantSku(
		masterVariantSku,
		masterVariantAttributes,
	)
	if (initialCylinderConfigurationVariantSku) {
		initialCylinderConfigurationVariant = await fetchCylinderConfigurationVariant(
			accessToken,
			initialCylinderConfigurationVariantSku,
			locale,
		)
	}

	const { countryCode } = getLanguageAndCountryCodeFromLocale(locale)
	const cylinderLockingMechanismProducts: Product["cylinderLockingMechanismProducts"] =
		await getCylinderLockingMechanismProducts(accessToken, masterVariantAttributes, countryCode)
	return {
		initialCylinderConfigurationVariant,
		cylinderLockingMechanismProducts,
	}
}

export default fetchInitialCylinderConfigurations
